import React from 'react';
import { Routes, Route } from 'react-router-dom';
import LuckyWheelLandingPage from './pages/LuckyWheelLandingPage';
import FootballPredictionPage from './pages/FootballPredictionPage';
import AdminLoginPage from './admin/AdminLoginPage';
import AdminDashboard from './admin/AdminDashboard';

function App() {
  return (
    <Routes>
      <Route path="/" element={<LuckyWheelLandingPage />} />
      <Route path="/football" element={<FootballPredictionPage />} />
      <Route path="/admin/login" element={<AdminLoginPage />} />
      <Route path="/admin/*" element={<AdminDashboard />} />
    </Routes>
  );
}

export default App;
